<template>
    
    <footer class="bg-white rounded-lg shadow dark:bg-gray-900 m-4">
        <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
            <div class="sm:flex sm:items-center sm:justify-between">
                <a href="/" class="flex items-center mb-4 sm:mb-0">
                    <nuxt-img format="webp" src="/HYS-logo-icon-06.png" class="h-8 mr-3" alt="HYS Logo" />
                    <span class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">{{ $t("global.site_title") }}</span>
                </a>
                <ul class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
                    <!-- <li>
                        <a href="#" class="mr-4 hover:underline md:mr-6 ">{{ $t("footer.about_us") }}</a>
                    </li> -->
                    <li>
                        <a href="/policy/medical-disclaimer" class="mr-4 hover:underline md:mr-6 ">{{ $t("footer.medical_disclaimer") }}</a>
                    </li>
                    <li>
                        <a href="/policy/tou" class="mr-4 hover:underline md:mr-6">{{ $t("footer.terms_of_use") }}</a>
                    </li>
                    <li>
                        <a href="/policy/privacy" class="mr-4 hover:underline md:mr-6 ">{{ $t("footer.privacy_policy") }}</a>
                    </li>
                    
                    <li>
                <a href="/sitemap.xml" class="hover:underline md:mr-6">{{ $t("footer.site_map") }}</a>
                    </li>
                    <li v-if="false">
                        <a href="/admin" class="hover:underline">Admin</a>
                    </li>
                </ul>
            </div>
            <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
            <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2018 - 2025 <a href="https://haodrs.com/" class="hover:underline">{{ $t("global.company_name") }}</a> {{ $t("footer.copy_right") }} </span>
            <ClientOnly>
                <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">UHEM Stack: {{config.public.STACK_VERSION}} - {{config.public.ENVIRONMENT}} - {{config.public.GIT_COMMIT_HASH}} ({{ config.public.ACTIVE_DEPLOYMENT_CONFIGURATION }})  </span>
            </ClientOnly>
        </div>
    </footer>


</template>

<script setup>
const config = useRuntimeConfig()

</script>

